import { useAtom } from "jotai";
import { useEffect } from "react";
import { useExpenseQuery } from "web_myplann/Api/Finances/useExpenseQuery";
import { useIncomeQuery } from "web_myplann/Api/Finances/useIncomeQuery";
import { financeState } from "web_myplann/Finances/State/FinanceAtom";
import { ClientFinancialPlanExpenseNameEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useFinanceData = () => {
	const { t } = useResource();

	const { data: expenses } = useExpenseQuery();
	const { data: income } = useIncomeQuery();

	const [finance, setFinance] = useAtom(financeState);

	useEffect(() => {
		if (income?.data || expenses?.data) {
			setFinance({
				income:
					income?.data?.map((e) => ({
						name: e.name ?? "",
						amount: e.amount,
					})) ?? [],
				expenses: expenses?.data ?? [],
			});
		}
	}, [income?.data, expenses?.data, setFinance]);

	const totalIncome =
		finance.income.length > 0
			? finance.income.reduce((acc, curr) => acc + curr.amount, 0)
			: (income?.data.reduce((acc, curr) => acc + curr.amount, 0) ?? 0);

	const incomeData =
		finance.income.length > 0
			? finance.income.map((e) => {
					return {
						value: e.amount,
						label: e.name ?? "",
					};
				})
			: (income?.data.map((e) => {
					return {
						value: e.amount,
						label: e.name ?? "",
					};
				}) ?? []);

	const totalExpenses =
		finance.expenses.length > 0
			? finance.expenses.reduce((acc, curr) => acc + curr.monthlyPayment, 0)
			: (expenses?.data.reduce((acc, curr) => acc + curr.monthlyPayment, 0) ??
				0);

	const expenseData =
		finance.expenses.length > 0
			? finance.expenses.map((e) => {
					return {
						value: e.monthlyPayment,
						label:
							e.name === ClientFinancialPlanExpenseNameEnum.Total
								? t(Resources.Finances.Expenses.Types[e.type].title)
								: t(Resources.Finances.Expenses.Names[e.name]),
					};
				})
			: (expenses?.data.map((e) => {
					return {
						value: e.monthlyPayment,
						label:
							e.name === ClientFinancialPlanExpenseNameEnum.Total
								? t(Resources.Finances.Expenses.Types[e.type].title)
								: t(Resources.Finances.Expenses.Names[e.name]),
					};
				}) ?? []);

	return { incomeData, totalIncome, totalExpenses, expenseData };
};
